import Visible from '@portalterreno/react-ui/Visible';
import { Col, Row } from '@portalterreno/react-ui-core/Grid';
import React from 'react';

import ButtonGoTop from './ButtonGoTop';
import FooterDesktop from './FooterDesktop';
import FooterMobile from './FooterMobile';
import StyledContainer from './StyledContainer';

export type FooterProps = Omit<
  React.HTMLAttributes<HTMLDivElement>,
  'children'
>;

const Footer: React.FC<FooterProps> = (props) => {
  return (
    <StyledContainer>
      <Row>
        <Col
          xs={4}
          lg={11}
          offset={{
            lg: 1
          }}
        >
          <Visible desktop>
            <ButtonGoTop />
            <FooterDesktop {...props} />
          </Visible>

          <Visible mobile>
            <FooterMobile {...props} />
          </Visible>
        </Col>
      </Row>
    </StyledContainer>
  );
};

export default Footer;
